import axios from 'axios';

const generateAdviceNote = (formData) => {
  const config = {
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
  };

  const body = {
    formData: formData,
  };

  return axios.post(`${process.env.NEXT_PUBLIC_GRAPPLE_BACKEND_URL}ms-grapple-ai`, body, config);
};

export default generateAdviceNote;
